export default "__VITE_ASSET__77eff758__"